/**
 * Mirrors the source of truth in
 * `services/core-api/src/v4/features/projects/enums/kind-of-research.enum.ts`.
 * Keep in sync.
 */
export enum KindOfResearch {
  ONE_ON_ONE = 1,
  FOCUS_GROUP = 2,
  /**
   * @deprecated
   */
  MULTI_DAY_STUDY = 3,
  UNMODERATED_STUDY = 4,
  /**
   * @deprecated
   */
  PHONE_INTERVIEW = 5,
  /**
   * @deprecated
   */
  USABILITY_TESTING = 6,
  IN_RESPONDENT_HOME = 8,
  SURVEY = 9,
  DIARY_STUDY = 10,
  IN_RESPONDENT_OFFICE = 11,
  AI_MODERATED_INTERVIEW = 12,
}
